import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormLabel, FormGroup } from 'react-bootstrap';
import MedicationManagement from 'App/components/MedicationManagement/MedicationManagement';
import PlaceHolderMessage from 'App/components/styles/PlaceholderMessage/PlaceHolderMessage';
import { TypeaheadInput } from 'Shared/form/TypeaheadField';
import useMedicationSearch from 'App/hooks/useMedicationSearch';

const propTypes = {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
    therapies: PropTypes.array.isRequired,
};

const defaultProps = {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/default-props-match-prop-types
    therapies: [],
};

function MedicationSearch(props) {
    const [selectedOption, setSelectedOption] = useState(null);
    const [searchValues, setSearchValues] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const { data: medGroups = [], isLoading: loading } = useMedicationSearch(inputValue || '');

    return (
        <div>
            <FormGroup style={{ width: '500px' }}>
                <FormLabel htmlFor="medication-select">Select a Medication</FormLabel>
                <TypeaheadInput
                    name="medication-select"
                    value={selectedOption}
                    options={medGroups}
                    getOptionValue={(option) => option.name}
                    getOptionLabel={(option) => option.name}
                    placeholder="Select a Medication"
                    filterOptionType="all"
                    onInputChange={setInputValue}
                    onChange={(option) => {
                        setSelectedOption(option);
                        if (option) {
                            setSearchValues(option.ids);
                        }

                        if (!option && inputValue) {
                            setInputValue('');
                        }
                    }}
                    isClearable
                    isLoading={loading}
                />
            </FormGroup>
            {searchValues ? (
                <MedicationManagement
                    searchValue={searchValues}
                    searchType="medication"
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line react/destructuring-assignment
                    therapies={props.therapies}
                />
            ) : (
                <PlaceHolderMessage placeholderText="Select a medication." />
            )}
        </div>
    );
}

MedicationSearch.propTypes = propTypes;
MedicationSearch.defaultProps = defaultProps;

export default MedicationSearch;
